{
  "translation": {
    "aboutMirador": "O Projektu Mirador",
    "aboutThisItem": "O ovom zapisu",
    "addedFromUrl": "(Dodano s URL-a)",
    "addManifestUrl": "Lokacija resursa",
    "addManifestUrlHelp": "URL IIIF resursa",
    "addResource": "Dodaj resurs",
    "annotationCanvasLabel_1/1": "Stavka: [{{label}}]",
    "annotationCanvasLabel_1/2": "Lijevo: [{{label}}]",
    "annotationCanvasLabel_2/2": "Desno: [{{label}}]",
    "annotations": "Anotacije",
    "attribution": "Pripisivanje",
    "attributionTitle": "Prava",
    "authenticationFailed": "Autentifikacija nije uspjela",
    "authenticationRequired": "Potrebna je autentifikacija za potpuni pristup",
    "backToResults": "Povratak na rezultate",
    "book": "Knjiga",
    "bottom": "Dno",
    "cancel": "Otkaži",
    "canvasIndex": "Indeks",
    "changeTheme": "Promijeni temu",
    "clearSearch": "očisti",
    "close": "Zatvori",
    "closeAddResourceForm": "Zatvori obrazac",
    "closeAddResourceMenu": "Zatvori popis resursa",
    "closeCompanionWindow": "Zatvori ploču",
    "closeWindow": "Zatvori prozor",
    "collapseSection": "Sažmi \"{{section}}\" odjeljak",
    "collapseSidePanel": "Sklopi bočnu traku",
    "collection": "Kolekcija",
    "continue": "Nastavi",
    "copy": "Kopiraj",
    "currentItem": "Trenutna stavka",
    "currentItem_1/1": "Trenutna stavka",
    "currentItem_1/2": "Lijevo",
    "currentItem_2/2": "Desno",
    "dark": "Tamna tema",
    "digitizedView": "Digitalizirani prikaz",
    "dismiss": "Odbaci",
    "displayNoAnnotations": "Istaknite ništa",
    "downloadExport": "Izvezi radni prostor",
    "downloadExportWorkspace": "Izvezi radni prostor",
    "elastic": "Elastičan",
    "elasticDescription": "Premještajte i mijenjajte veličinu prozora slobodno u neograničenom radnom prostoru. Prozori se mogu preklapati.",
    "emptyResourceList": "Vaš popis resursa je prazan",
    "error": "Greška",
    "errorDialogConfirm": "U redu",
    "errorDialogTitle": "Došlo je do greške",
    "exitFullScreen": "Izađi iz punog zaslona",
    "expandSection": "Proširi odjeljak \"{{section}}\"",
    "expandSidePanel": "Proširi bočnu traku",
    "exportCopied": "Konfiguracija radnog prostora kopirana je u vaš međuspremnik",
    "fetchManifest": "Dodaj",
    "fullScreen": "Cijeli ekran",
    "gallery": "Galerija",
    "hideZoomControls": "Sakrij kontrole zuma",
    "highlightAllAnnotations": "Istakni sve",
    "iiif_homepage": "O ovom resursu",
    "iiif_manifest": "IIIF manifest",
    "iiif_related": "Srodno",
    "iiif_renderings": "Alternativni formati",
    "iiif_seeAlso": "Vidi također",
    "import": "Uvoz",
    "importWorkspace": "Uvezi radni prostor",
    "importWorkspaceHint": "Zalijepite konfiguraciju Mirador 4 koju treba uvesti",
    "item": "Stavka: {{label}}",
    "itemList": "Popis stavki",
    "jsError": "Tehnički detalji",
    "jsStack": "{{ stack }}",
    "language": "Jezik",
    "layer_hide": "Sakrij sloj",
    "layer_move": "Premjesti sloj",
    "layer_opacity": "Prozirnost sloja",
    "layer_show": "Prikaži sloj",
    "layers": "Slojevi",
    "light": "Svijetla tema",
    "links": "Poveznice",
    "listAllOpenWindows": "Skoči do prozora",
    "login": "Prijavi se",
    "logout": "Odjavi se",
    "manifestError": "Resurs se ne može dodati",
    "maximizeWindow": "Maksimiziraj prozor",
    "minimizeWindow": "Minimiziraj prozor",
    "mirador": "Mirador",
    "miradorResources": "Mirador resursi",
    "miradorViewer": "Preglednik Mirador",
    "more": "još...",
    "moreResults": "Više rezultata",
    "mosaic": "Mozaik",
    "mosaicDescription": "Pomičite i mijenjajte veličinu prozora u odnosu jedan prema drugom, unutar vidljivog okvira.",
    "moveCompanionWindowToBottom": "Pomakni se na dno",
    "moveCompanionWindowToRight": "Pomakni se udesno",
    "multipartCollection": "Višedijelna zbirka",
    "nextCanvas": "Sljedeća stavka",
    "noItemSelected": "Nijedna stavka nije odabrana",
    "numItems_one": "{{number}} predmet",
    "numItems_other": "{{number}} artikala",
    "off": "Isključeno",
    "openCompanionWindow_annotations": "Bilješke",
    "openCompanionWindow_attribution": "Prava",
    "openCompanionWindow_canvas": "Indeks",
    "openCompanionWindow_info": "Informacija",
    "openCompanionWindow_layers": "Slojevi",
    "openCompanionWindow_search": "Pretraživanje",
    "openInCompanionWindow": "Otvori u zasebnom panelu",
    "openWindows": "Trenutno otvoreni prozori",
    "pagination": "{{current}} od {{total}}",
    "position": "Pozicija",
    "previewWindowTitle": "{{title}}",
    "previousCanvas": "Prethodna stavka",
    "related": "Srodno",
    "resource": "Resurs",
    "retry": "Pokušaj ponovno",
    "right": "Desno",
    "rights": "Licenca",
    "scroll": "Pomakni",
    "searchInputLabel": "pojmovima pretraživanja",
    "searchNextResult": "Sljedeći rezultat",
    "searchNoResults": "Nema rezultata",
    "searchPreviousResult": "Prethodni rezultat",
    "searchResultsRemaining": "Preostalo je {{numLeft}}",
    "searchSubmitAria": "Podnesi pretragu",
    "searchTitle": "Pretraživanje",
    "selectWorkspaceMenu": "Odaberite vrstu radnog prostora",
    "showCollection": "Prikaži kolekciju",
    "showingNumAnnotations_one": "Prikazivanje {{number}} bilješke",
    "showingNumAnnotations_other": "Prikazivanje {{number}} bilješki",
    "showZoomControls": "Prikaži kontrole zumiranja",
    "sidebarPanelsNavigation": "Bočne ploče navigacija",
    "single": "Jedan",
    "startHere": "Počnite ovdje",
    "suggestSearch": "Pretraži ovaj dokument za \"{{ query }}\"",
    "tableOfContentsList": "Sadržaj",
    "theme": "Tema",
    "thumbnailList": "Popis sličica",
    "thumbnailNavigation": "Sličice",
    "thumbnails": "Sličice",
    "toggleWindowSideBar": "Prebaci bočnu traku",
    "totalCollections_one": "{{count}} kolekcija",
    "totalCollections_other": "{{count}} kolekcija",
    "totalManifests_one": "{{count}} manifest",
    "totalManifests_other": "{{count}} manifesta",
    "tryAgain": "Pokušaj ponovno",
    "untitled": "[Nenaslovljeno]",
    "view": "Pogled",
    "viewWorkspaceConfiguration": "Pogledaj konfiguraciju radnog prostora",
    "welcome": "Dobrodošli u Mirador",
    "window": "Prozor: {{label}}",
    "windowMenu": "Prikazi prozora i prikaz sličica",
    "windowNavigation": "Navigacija prozorom",
    "windowPluginButtons": "Opcije",
    "windowPluginMenu": "Opcije prozora",
    "workspace": "Radni prostor",
    "workspaceFullScreen": "Puni zaslon",
    "workspaceMenu": "Postavke radnog prostora",
    "workspaceNavigation": "Navigacija radnog prostora",
    "workspaceOptions": "Opcije radnog prostora",
    "workspaceSelectionTitle": "Odaberite vrstu radnog prostora",
    "zoomIn": "Povećaj",
    "zoomOut": "Umanji prikaz",
    "zoomReset": "Poništi zumiranje"
  }
}
